module.exports = __webpack_public_path__ + "static/SOliverxTrampolin-2a1a5939ca7d6cca5e8f45f7991e7b12.mp4";